import { Duration, Schema } from 'effect';

export const documentInsightsTimeouts = {
  generation: Duration.minutes(6),
  pending: Duration.minutes(7),
  recoveryGrace: Duration.minutes(1),
};

export const DocumentInsightsModel = Schema.Literals([
  'auto',
  'openai/gpt-oss-120b',
  'google/gemma-4-31b-it',
  'qwen/qwen3.7-flash',
  'google/gemma-4-26b-a4b-it',
  'openai/gpt-5.6-luna',
]);

export const DocumentInsightsContext = Schema.Literals([
  '2000',
  '4000',
  'full',
]);

export const DocumentInsightsFailureReason = Schema.Literals([
  'no-text',
  'interrupted',
  'provider',
]);

export const DocumentInsightsRequest = Schema.Struct({
  requestId: Schema.String.check(Schema.isUUID(4)),
  model: DocumentInsightsModel,
  context: DocumentInsightsContext,
});

export const DocumentInsightsResult = Schema.Struct({
  model: DocumentInsightsModel,
  context: DocumentInsightsContext,
  description: Schema.NullOr(Schema.String),
  summary: Schema.NullOr(Schema.String),
  keyPoints: Schema.NullOr(Schema.String),
  rawResponse: Schema.String,
  durationMs: Schema.Finite,
  costUsd: Schema.NullOr(Schema.Finite),
  inputTokens: Schema.NullOr(Schema.Finite),
  outputTokens: Schema.NullOr(Schema.Finite),
  sourceWords: Schema.Int,
  sentWords: Schema.Int,
  fallbackCount: Schema.optional(Schema.Int),
  costIncomplete: Schema.optional(Schema.Boolean),
});

export const DocumentInsightsProgress = Schema.TaggedStruct(
  'DocumentInsightsProgress',
  {
    phase: Schema.Literals(['reading', 'summarizing', 'fallback', 'writing']),
    model: DocumentInsightsModel,
    completedSections: Schema.Int,
    totalSections: Schema.Int,
    startedAt: Schema.Finite,
    updatedAt: Schema.Finite,
    deadlineAt: Schema.Finite,
    estimatedRemainingMs: Schema.Finite,
  },
);

export const suggestedDocumentInsightsModel = () => 'auto' as const;

export const DocumentInsightsSelection = Schema.Struct({
  model: DocumentInsightsModel,
  context: DocumentInsightsContext,
});

export const EnsureDocumentInsightsRequest = Schema.Struct({
  ...DocumentInsightsRequest.fields,
  retryRequestId: Schema.optional(DocumentInsightsRequest.fields.requestId),
});

export const DocumentInsightsFailure = Schema.Struct({
  message: Schema.String,
  reason: Schema.optional(DocumentInsightsFailureReason),
});

export const SavedDocumentInsights = Schema.Union([
  Schema.Struct({
    status: Schema.Literal('pending'),
    requestId: DocumentInsightsRequest.fields.requestId,
    progress: Schema.NullOr(DocumentInsightsProgress),
  }),
  Schema.Struct({
    status: Schema.Literal('completed'),
    requestId: DocumentInsightsRequest.fields.requestId,
    result: DocumentInsightsResult,
  }),
  Schema.Struct({
    status: Schema.Literal('failed'),
    requestId: DocumentInsightsRequest.fields.requestId,
    error: DocumentInsightsFailure,
  }),
]);

export const documentInsightsPersistenceVersion = 1;
